import HomePage from "./homePage";

const routes = [
    {path : 'company/:company/home', component : () => <HomePage/>, isSidebar : true, isPublic : false , permissions:['view_home']},

]

export default routes;